import { render, staticRenderFns } from "./zjzk.vue?vue&type=template&id=e97f5fe0&"
import script from "./zjzk.vue?vue&type=script&lang=js&"
export * from "./zjzk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports